// extracted by mini-css-extract-plugin
export default {"select":"HdgO4m"};